import type { Stripe } from '@stripe/stripe-js'

import { config } from '@/lib/helpers'

export const stripe: Stripe = window.Stripe(config.stripePublicKey)
